import { axiosWithAuth, convertDateToISO, TIME_OFFSET_DAY_END } from "helpers";

export const reportsService = {
	getReportsList,
	getReportForDisplay,
	downloadReport,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

const mapReportsListParams = ({ page, filters, sortBy }) => ({
	page_index: page,
	page_size: PAGE_SIZE,

	from: convertDateToISO(filters?.date?.[0]),
	to: convertDateToISO(filters?.date?.[1], { addTime: TIME_OFFSET_DAY_END }),
	name: filters?.reportName,
	repository: filters?.repository?.name,
});

function getReportsList({ page, filters, sortBy }) {
	const options = {
		url: `${API_URL}/api/reports`,
		params: mapReportsListParams({ page, filters, sortBy }),
	};

	return axiosWithAuth(options);
}

function getReportForDisplay(
	reportId: string,
	fileFormat: string | number,
	token: string,
) {
	const url = `${API_URL}/api/reports/${reportId}/download/${fileFormat}?token=${token}`;

	return url;
}

function downloadReport(
	reportId: string,
	fileFormat: string | number,
	token: string,
) {
	const url = `${API_URL}/api/reports/${reportId}/download/${fileFormat}?token=${token}`;
	let link = document.createElement("a");
	link.href = url;
	link.click();
}
